import { render, staticRenderFns } from "./RegistrationBox.vue?vue&type=template&id=df9adcd8&scoped=true&"
import script from "./RegistrationBox.vue?vue&type=script&lang=js&"
export * from "./RegistrationBox.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationBox.vue?vue&type=style&index=0&id=df9adcd8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9adcd8",
  null
  
)

export default component.exports